var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoutingImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_360_298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.92006 3.06649C5.38672 0.759819 1.91339 0.753152 1.38006 3.06649C1.06672 4.41982 1.92672 5.56649 2.67339 6.27982C3.22006 6.79315 4.08006 6.79315 4.62672 6.27982C5.37339 5.56649 6.22672 4.41982 5.92006 3.06649ZM3.67339 4.13315C3.30672 4.13315 3.00672 3.83315 3.00672 3.46649C3.00672 3.09982 3.30006 2.79982 3.66672 2.79982H3.67339C4.04672 2.79982 4.34006 3.09982 4.34006 3.46649C4.34006 3.83315 4.04672 4.13315 3.67339 4.13315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6067 11.0665C14.0733 8.75982 10.5867 8.75315 10.0467 11.0665C9.73333 12.4198 10.5933 13.5665 11.3467 14.2798C11.8933 14.7932 12.76 14.7932 13.3067 14.2798C14.06 13.5665 14.92 12.4198 14.6067 11.0665ZM12.3533 12.1332C11.9867 12.1332 11.6867 11.8332 11.6867 11.4665C11.6867 11.0998 11.98 10.7998 12.3467 10.7998H12.3533C12.72 10.7998 13.02 11.0998 13.02 11.4665C13.02 11.8332 12.72 12.1332 12.3533 12.1332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13.1666H6.21333C5.44 13.1666 4.76667 12.6999 4.5 11.9799C4.22667 11.2599 4.42667 10.4666 5.00667 9.95325L10.3333 5.29325C10.6533 5.01325 10.66 4.63325 10.5667 4.37325C10.4667 4.11325 10.2133 3.83325 9.78667 3.83325H8C7.72667 3.83325 7.5 3.60659 7.5 3.33325C7.5 3.05992 7.72667 2.83325 8 2.83325H9.78667C10.56 2.83325 11.2333 3.29992 11.5 4.01992C11.7733 4.73992 11.5733 5.53325 10.9933 6.04658L5.66667 10.7066C5.34667 10.9866 5.34 11.3666 5.43333 11.6266C5.53333 11.8866 5.78667 12.1666 6.21333 12.1666H8C8.27333 12.1666 8.5 12.3933 8.5 12.6666C8.5 12.9399 8.27333 13.1666 8 13.1666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_360_298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutingImage);
export default __webpack_public_path__ + "static/media/routingImage.b7aa4be107736ff0e6e68a13a9cfe59b.svg";
export { ForwardRef as ReactComponent };